import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomLoaderService } from '../../services/custom-loader.service';
import { MainHeaderMenuService } from '../../services/main-header-menu.service';
import { EncrdecrService } from '../../Auth/encrdecr.service';
import { ClientDataService } from '../../services/client-data.service';
import { environment } from 'src/environments/environment';
import { isEmailValidate, isNullOrUndefined, IsValidMobile, IsValidOTP, IsValidPAN } from '../../validation';
import { CodifyLoginService } from '../../services/codify-login.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DatePipe } from '@angular/common';
import { LoginService } from '../../services/login.service';
import { compileDeclareNgModuleFromMetadata } from '@angular/compiler';
import { ProfileService } from 'src/app/services/profile.service';
import { CleverTapUtilityService } from 'src/app/services/clever-tap-utility.service';

declare var $: any;

@Component({
  selector: 'app-codify-login',
  templateUrl: './codify-login.component.html',
  styleUrls: ['./codify-login.component.scss']
})
export class CodifyLoginComponent {
  // @ViewChild('ngCodifyOtpInput', { static: false }) ngCodifyOtpInput: any;
  config = {
    length: 6,
    inputClass: 'OTPBox',
    allowNumbersOnly: true,
    inputStyles: {
      'text-security': 'disc',
      '-webkit-text-security': 'disc',
      '-moz-text-security': 'disc'
    },
    disableAutoFocus: false
  }
  // [config]="{
  //   length: 6,
  //   inputClass: 'OTPBox',
  //   allowNumbersOnly: true,
  //   disableAutoFocus: false,
  //   inputStyles: {
  //   'text-security': 'disc',
  //   '-webkit-text-security': 'disc',
  //   '-moz-text-security': 'disc'
  //   },
  //   isNumberInput: true
  //   }"
  IsInvestor: boolean = false;
  LoginForm: FormGroup;
  LoginSubmitted: boolean = false;
  UserType: number = 3;
  IsShowLoginOption: boolean = true;
  WelcomeText: any = '';
  CompanyName: string = '';
  logo: string;
  NavHeight: string;
  IsMobile: boolean = false;
  logoWidth: string;
  logoHeight: string;
  MobileLoginForm: FormGroup;
  isMobileLoginFormSubbmitted: boolean = false;
  isMobileListDisplay: boolean = false;
  CurrentCompanyName: string = environment.CompayName;
  EmailLoginForm: FormGroup;
  isEmailFormSubbmitted: boolean = false;
  isEmailListDisplay: boolean = false;
  ClientData: any = [];
  ClientDataBasedOnEmail: any = [];
  characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  redirect_fd: any;
  redirect_mf: any;
  redirect_nfo: any;
  redirect_preferscheme: any;
  redirectTo: string = "";
  TakeMeToPage: string = "/client-dashboard";
  USERLoginId: any;
  Token: string;
  TokenArray: string[] = [];
  UserId: string;
  Password: string;
  UserTypeSSO: string;
  PageURL: string;
  PageView: boolean = false; // display cp login page or not
  CodifyOTPForm: FormGroup;
  OTPFormSubmitted: boolean = false;
  CodifyPANForm: FormGroup;
  PANFormSubmitted: boolean = false;
  CodifyValidateRes: any
  utm_source: string = "";
  OtpTimer: number = 60;
  OtpTimeRemening: any = "01:00";
  OTP_Timer_Function: any;
  isDisabled: boolean = true;
  ResendOTPMessage: string;
  CodifyValidateRes_ResendOTP: any;
  Data: any;
  DataArray: any;
  PageId: any;
  URL: string = "";
  G_ClientBasicInfoId: string;
  accessToken: any;
  IsShowInvalidOTPMsg: boolean = false;
  APPSOURCE:string = ""
  dplk:string = ""
  IsFromDeepLink: boolean = false;

  constructor(private LoginService: CodifyLoginService,
    private loginService: LoginService,
    private datepipe: DatePipe,
    private EncrdecrService: EncrdecrService,
    public ShowHideHeaderMenu: MainHeaderMenuService,
    private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private Loader: CustomLoaderService,
    private ClientDataService: ClientDataService,
    private bsModalRef: BsModalRef,private clientProfileService: ProfileService,
    private Clevertap:CleverTapUtilityService

  ) {
    this.LoginForm = this.formBuilder.group({
      Username: ['', Validators.required],
      Password: ['', [Validators.required]],
      UserType: ['3']
    });
    this.MobileLoginForm = this.formBuilder.group({
      Mobile: ['', [Validators.required, Validators.pattern(IsValidMobile)]],
      MobileOTP: ['', [Validators.required, Validators.pattern(IsValidOTP)]],
    });

    this.EmailLoginForm = this.formBuilder.group({
      Email: ['', [Validators.required, Validators.pattern(isEmailValidate)]],
      EmailOTP: ['', [Validators.required, Validators.pattern(IsValidOTP)]],
    });

    this.CodifyOTPForm = this.formBuilder.group({
      OTP: ['', [Validators.required, Validators.minLength(6)]]
    });

    this.CodifyPANForm = this.formBuilder.group({
      PAN: ['', [Validators.required, Validators.pattern(IsValidPAN)]]
    });
  }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
      this.router.navigateByUrl("/mobilesession")
    }
    else {
      this.IsMobile = false;
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth)
  }

  ngOnInit() {
    //Added by Dalsukh (SSO Verification Module)
    this.route.queryParams.subscribe(params => {
      // console.log("Params",params);
      this.Loader.show();
      this.Token = params['Data'];
      let parameters = params.dplk; 
      if(!isNullOrUndefined(parameters) && parameters != "" && parameters != "0"){
        let Param = parameters.replace(/ /g, "+");
        console.log(" value ->", Param);
        sessionStorage.setItem('OPHqexF834YT4HhjG8', Param); //  DeepLinkId
        this.IsFromDeepLink = true;
      }
      else{
        this.IsFromDeepLink = false;
      }
      if (this.Token) {
        this.PageView = true;
        debugger
        this.LoginForm.controls["Username"].setValue(this.EncrdecrService.getDecr(sessionStorage.getItem('1rMWoq/fR0KsYA9AxL63Cw=='))); // Userid
        this.LoginForm.controls["Password"].setValue(this.EncrdecrService.getDecr(sessionStorage.getItem('HNrvPKl2xEC1ZGyPqCxAOQ=='))); //Password
        this.PageURL = this.EncrdecrService.getDecr(sessionStorage.getItem('+TrzWUXUJ0Cd20+J77gj4A==')) //Page URL
        this.onSubmit()
      }

    });


    //Added by Dalsukh 14-02-2025

    let Token: string = "";
    let ClientCode: any = "";
    let PageId: any = "";
    let ComingTime: string;
    debugger

    this.route.queryParams.subscribe(params => {
      this.Data = params['data'];
      this.dplk = params['dplk'];
      console.log(this.Data);
    });

    debugger
    if (this.Data != null) {
      this.Data = this.Data.toString().replaceAll(" ", "+");
      debugger
      debugger

      this.Data = this.EncrdecrService.getDecr(this.Data);
      this.DataArray = this.Data.split("`");
      Token = this.DataArray[0];
      ClientCode = this.DataArray[1];
      PageId = this.DataArray[2];
      this.PageId = PageId;
      ComingTime = this.DataArray[3];
      let Jid = ComingTime;
      let AppSource = this.DataArray[4];

      if(!isNullOrUndefined(this.dplk) && this.dplk != "" && this.dplk != "0"){
        sessionStorage.setItem('OPHqexF834YT4HhjG8', this.dplk);
        this.IsFromDeepLink = true;
      }
      else{
        this.IsFromDeepLink = false;
      }

      this.APPSOURCE = AppSource

      sessionStorage.setItem("sxafkmoscmoascok", AppSource);

      ComingTime = ComingTime.substring(0, 19)
      const date2 = new Date();
      let Current = this.formatDate(date2);

      console.log(Current);
      console.log(ComingTime);
      // const date1 = new Date(ComingTime);
      //   console.log(date2,ComingTime);
      //   console.log(date2)
      //   console.log(Math.abs(date2.getTime()));
      //   console.log(Math.abs(date1.getTime()));

      // const differenceInMilliseconds = Math.abs(date2.getTime() - date1.getTime());
      // const differenceInMinutes = differenceInMilliseconds / (1000 * 60); // Convert milliseconds to minutes
      //      console.log(differenceInMinutes)
      // if (differenceInMinutes > 2) {
      //  // this.Callaler("time goes");
      //   return ;
      // }
      let diff = this.getDifferenceInMinutes(ComingTime, Current);
      console.log(this.getDifferenceInMinutes(ComingTime, Current));

      if (Token != "" && ClientCode != "" && PageId != "") {
        let request = {
          userId: ClientCode,
          token: Token,
          PageId: PageId,
          Jid: Jid
        }

        this.loginService.checkIIFLToken(request).subscribe(
          (response: any) => {
            debugger

            let res = JSON.parse(this.EncrdecrService.getDecr(response))

            if (res.ArrayOfResponse != null && res.ArrayOfResponse != undefined) {

              if (res.Message == "Unsuccessful Response") {
                //this.CallAlertModal("Usertid or password is incorrects");
                window.location.href = '/login-incred';
              }

              if (res.ArrayOfResponse.length === 1 || res.ArrayOfResponse.length >= 1) {
                // res.ArrayOfResponse[0].Password = this.EncrdecrService.getDecr(res.ArrayOfResponse[0].Password)
                this.URL = res.ArrayOfResponse[0].PageUrl;
                res.ArrayOfResponse[0].password = res.ArrayOfResponse[0].Password;
                // const json = {
                //   "Username": res.ArrayOfResponse[0].PANNo,
                //   "Password": res.ArrayOfResponse[0].Password
                // }
                // let databody = JSON.stringify(json);
                this.getCompanyDetails('no'); //Added by Tishya
                this.onPanNumberLogin(res.ArrayOfResponse);
                //this.callAuthenticationController(databody)
              }
              else {
                this.Loader.hide();
                window.location.href = '/login-incred';
              }
              // this.Loader.hide();
            } else {
              this.Loader.hide();
              window.location.href = '/login-incred';
            }
          }, (err: any) => {
            console.log(err);
            this.Loader.hide();
          })
      }
      else {
        window.location.href = '/login-incred';
      }

    }

    else {

      this.SetViewPort(window.innerWidth);
      this.getCompanyDetails();
      sessionStorage.setItem("nvjsd212djskd$#21ksdj", "SB")
      this.WelcomeText = this.ClientDataService.GetWelcomeText();
      this.logo = sessionStorage.getItem('logo');
      this.CompanyName = this.ClientDataService.GetCompanyName();
      if (this.CompanyName == 'Mahindra') {
        this.logoWidth = '330px';
        this.logoHeight = '120px';
        this.NavHeight = '40px';
        $('.MainOuter').css('min-height', window.innerHeight - 70);
      }
      else if (this.CompanyName == 'AU') {
        this.logoWidth = '130px';
        this.logoHeight = '60px';
        this.NavHeight = '62px';
        $('.MainOuter').css('min-height', window.innerHeight - 0);
        $('.LoginOuter').css('min-height', '100vh');
      }
      else if (this.CompanyName == 'YesSecurities') {
        this.logoWidth = '150px';
        this.logoHeight = '60px';
        this.NavHeight = '62px';
        $('.MainOuter').css('min-height', window.innerHeight - 75);
      }

      const CorporateFag = sessionStorage.getItem('Vbhs@#%LMKIo=');
      if (CorporateFag == 'C') {

        //this.ShowHideHeaderMenu.hide();
        sessionStorage.removeItem('F44sGAGh2xwkpUL');//Session_SubBrokerId
        sessionStorage.removeItem('Hldq31TLYwRbLJ8');//Session_SubBrokerCode
        sessionStorage.removeItem('UZT6qHaDZSz66kx'); //Session_ClientBasicInfoId
        sessionStorage.removeItem('N1QJHdOkO7Hz8QC'); //Session_ClientBasicInfoId
        sessionStorage.removeItem('L2D3506kIHSk3E0'); //Session_UserType
        sessionStorage.removeItem('pOWgAF62qFXnZMn'); // Session_Razor
        sessionStorage.removeItem('W113TKilrF1u1gL'); // ucc code - client
        sessionStorage.removeItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
        sessionStorage.removeItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294');
        sessionStorage.removeItem('hn0bHyGhfpGtrPe'); //family id
        sessionStorage.removeItem('E#$%#XCha7%*=');
        sessionStorage.removeItem('Vbhs@#%LMKIo=');

      }
      else {
        this.router.parseUrl("**");
      }
    }
  }
  ngAfterViewInit() {
    $(".TakeMeTo_DDl").select2({
      minimumResultsForSearch: -1,
      dropdownCssClass: 'TakeMeTo_Dropdown',
      containerCssClass: 'TakeMeTo_Container'
    });
    $(".TakeMeTo_DDl").on('change', (e: any) => {
      this.TakeMeToPage = $(e.target).val();
    });
    // let loaderInterval = setInterval(() => {
    //   let str = document.readyState;
    //   if (str == 'complete') {
    //     let id = $('.ng-otp-input-wrapper .otp-input:first-child').attr('id');
    //     console.log(id);
    //     this.ngCodifyOtpInput.focusTo(id);
    //     clearInterval(loaderInterval)
    //   }
    // }, 1000);
  }
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');  // Month is 0-based, so add 1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Format the date in YYYY-MM-DDTHH:mm:ss format
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }
  getDifferenceInMinutes(date1: string, date2: string): number {
    // Convert the date strings to Date objects
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    // Calculate the difference in milliseconds
    const diffInMilliseconds = Math.abs(d2.getTime() - d1.getTime());

    // Convert milliseconds to minutes
    const diffInMinutes = diffInMilliseconds / (1000 * 60);

    return diffInMinutes;
  }

  get r() {
    return this.LoginForm.controls;
  }

  get j() {
    return this.MobileLoginForm.controls;
  }

  get e() {
    return this.EmailLoginForm.controls;
  }

  isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  SendOtpToEmail() {

    let Email = this.EmailLoginForm.controls["Email"].value;
    if (Email == "") {
      this.CallAlertModal("Please enter email address.")
    } else {
      var pattern = new RegExp(isEmailValidate);
      var result = pattern.test(Email);
      if (result == true) {
        const EmailRequest = {
          "USER_TYPE": '2',
          "VERIFICATION_ID": 'IFDEmailOTPLogin',
          "FullName": this.EmailLoginForm.controls["Email"].value,
          "EmailId": this.EmailLoginForm.controls["Email"].value,
          "Trans_Type": 'EmailID',
          "Flag": "G"
        }
        var json = JSON.stringify(EmailRequest);
        this.SendEmailOTP(json);
      } else {
        this.CallAlertModal("Invalid Email Address")
        this.EmailLoginForm.reset();
      }
    }
  }

  onClickReSendEmailOTP() {

    let Email = this.EmailLoginForm.controls["Email"].value;
    if (Email == "") {
      this.CallAlertModal("Please enter email address.")
    } else {
      var pattern = new RegExp(isEmailValidate);
      var result = pattern.test(Email);
      if (result == true) {
        this.Loader.show();
        const EmailRequest = {
          "USER_TYPE": '2',
          "VERIFICATION_ID": 'IFDEmailOTPLogin',
          "FullName": this.EmailLoginForm.controls["Email"].value,
          "EmailId": this.EmailLoginForm.controls["Email"].value,
          "Trans_Type": 'EmailID',
          "Flag": "G"
        }
        var json = JSON.stringify(EmailRequest);
        this.SendEmailOTP(json);
      } else {
        this.CallAlertModal("Invalid Email Address")
        this.EmailLoginForm.reset();
      }
    }
  }

  OnClickReSendButton() {
    let mobile = this.MobileLoginForm.controls["Mobile"].value;
    if (mobile == "") {
      this.CallAlertModal("please Enter Mobile number !!")
    } else {
      if (mobile.length == 10) {
        var pattern = new RegExp(IsValidMobile);
        var result = pattern.test(mobile);
        if (result == true) {
          this.Loader.show();
          const request = {
            "USER_TYPE": '2',
            "VERIFICATION_ID": 'IFDMobileOTPLogin',
            "FullName": "",
            "MobileNo": this.MobileLoginForm.controls["Mobile"].value,
            "Trans_Type": "Mobile",
            "Flag": "G",
          };
          var json = JSON.stringify(request);
          this.SendMobileOTP(json);
        } else {
          this.CallAlertModal("invalid Mobile number !!")
          this.MobileLoginForm.reset();
        }
      } else {
        this.CallAlertModal("invalid Mobile number !!")
        this.MobileLoginForm.reset();
      }
    }
  }

  SendOtpToMobile() {

    let mobile = this.MobileLoginForm.controls["Mobile"].value;
    if (mobile.length == 10) {
      var pattern = new RegExp(IsValidMobile);
      var result = pattern.test(mobile);
      if (result == true) {
        this.Loader.show();
        const request = {
          "USER_TYPE": '2',
          "VERIFICATION_ID": 'IFDMobileOTPLogin',
          "FullName": "",
          "MobileNo": this.MobileLoginForm.controls["Mobile"].value,
          "Trans_Type": "Mobile",
          "Flag": "G",
        };
        var json = JSON.stringify(request);
        this.SendMobileOTP(json);
      } else {
        this.CallAlertModal("Invalid Mobile number");
        this.MobileLoginForm.reset();
      }
    } else {
      this.CallAlertModal("Invalid Mobile number");
      this.MobileLoginForm.reset();
    }

  }

  SendMobileOTP(request: any) {
    this.LoginService.JMOTPMobile(request).subscribe(
      (response: any) => {
        let res = JSON.parse(this.EncrdecrService.getDecr(response))

        this.Loader.hide();
        if (res.Message == "Success") {
          this.CallAlertModal("OTP sent to your mobile no...")
        } else if (res.Message == "Overlimit") {
          this.CallAlertModal("Overlimit")
        } else {
          this.CallAlertModal("OTP operation Faild...")
        }
      }, (err: any) => {
        console.log(err);
      })
  }

  SendEmailOTP(EmailRequest: any) {
    this.LoginService.JMOTPEmail(EmailRequest).subscribe(
      (response: any) => {
        let res = JSON.parse(this.EncrdecrService.getDecr(response))

        this.Loader.hide();
        if (res.Message == "Success") {
          this.CallAlertModal("OTP sent to your EmailID...")
        } else if (res.Message == "Overlimit") {
          this.CallAlertModal("Overlimit")
          this.EmailLoginForm.reset();
        } else {
          this.CallAlertModal("OTP operation Faild...")
          this.EmailLoginForm.reset();
        }
      }, (err: any) => {
        console.log(err);
      })
  }

  OnMobileLogin() {

    let RandomKey = "";
    RandomKey = this.generateRandomString(6)
    this.isMobileLoginFormSubbmitted = true;
    if (this.MobileLoginForm.invalid) {
      return
    } else {
      this.Loader.show();
      const MobileVerifyRequest = {
        "FullName": "Chirag Dhruv",
        "MobileNo": this.MobileLoginForm.controls["Mobile"].value,
        "Trans_Type": "Mobile",
        "Flag": "V",
        "OTP": this.MobileLoginForm.controls["MobileOTP"].value,
        "RandomKey": RandomKey
      };
      var json = JSON.stringify(MobileVerifyRequest);
      this.LoginService.JMOTPMobile(json).subscribe(
        (response: any) => {
          let key = ''
          let message = ''
          let res = JSON.parse(this.EncrdecrService.getDecr(response))
          key = res.Message.split('|')[0]
          message = res.Message.split('|')[1]

          if (message == "Verified" && key == RandomKey) {
            this.Loader.hide();
            this.CallAlertModal("OTP Verified Successfully");
            const json = {
              "MobileNo": this.MobileLoginForm.controls["Mobile"].value,
              "Email": "",
              "flag": "BasedOnMobile",
              "UserType": this.UserType
            }
            let data = JSON.stringify(json)
            this.Loader.show();
            this.LoginService.fetchSubBrokerDetailsBasedOnMobile(data).subscribe(
              (response: any) => {
                let result = JSON.parse(this.EncrdecrService.getDecr(response))
                if (result.ArrayOfResponse != null && result.ArrayOfResponse != undefined) {
                  console.log(result.ArrayOfResponse);
                  ;
                  this.Loader.hide();
                  //if(result.ArrayOfResponse.length === 1 || result.ArrayOfResponse.length >= 1){
                  if (result.ArrayOfResponse.length === 1) {
                    let password = this.EncrdecrService.getDecr(result.ArrayOfResponse[0].Password)
                    console.log(password);
                    const json = {
                      "Username": result.ArrayOfResponse[0].SubBrokerCode,
                      "Password": password
                    }
                    let databody = JSON.stringify(json);
                    this.callAuthenticationController(databody)
                  } else {
                    if (result.ArrayOfResponse.length === 0) {
                      this.CallAlertModal("unauthorized user Sorry..please contact Branch.");
                      this.MobileLoginForm.reset();
                    } else {
                      this.Loader.hide();
                      this.ClientData = result.ArrayOfResponse
                      this.isMobileListDisplay = true;
                      $('#AlertModal').modal('hide');
                      $('#AlertModalLogin').modal({
                        backdrop: 'static',
                        keyboard: false
                      });
                    }
                  }
                }
              }), (err: any) => {
                console.log(err);
                this.Loader.hide();
              }
          } else if (res.Message == "OTP Code is Expired") {
            this.Loader.hide();
            this.CallAlertModal("OTP Code is Expired")
            this.MobileLoginForm.reset();
          } else if (res.Message == "User Not Exist") {
            this.Loader.hide();
            this.CallAlertModal(res.Message);
            this.MobileLoginForm.reset();
            this.isMobileListDisplay = false;
          } else if (res.Message == "Overlimit") {
            this.Loader.hide();
            this.CallAlertModal("Overlimit!! please try after 5 minutes.");
            this.MobileLoginForm.reset();
            this.isMobileListDisplay = false;
          } else if (res.Message == "Invalid OTP Code") {
            this.Loader.hide();
            this.CallAlertModal("Invalid OTP Code");
            this.MobileLoginForm.reset();
            this.isMobileListDisplay = false;
          } else {
            this.Loader.hide();
            this.CallAlertModal("Verified operation Faild...")
            this.MobileLoginForm.reset();
            this.isMobileListDisplay = false;
          }
        })
        , (err: any) => {
          console.log(err)
          this.Loader.hide();
        }
    }
  }

  onEmailLoginClick() {
    this.isEmailFormSubbmitted = true;
    let RandomKey = "";
    RandomKey = this.generateRandomString(6)
    if (this.EmailLoginForm.invalid) {
      return
    } else {
      this.Loader.show();
      let Email = this.EmailLoginForm.controls["Email"].value;
      const EmailVerifyRequest = {
        "FullName": "",
        "EmailId": this.EmailLoginForm.controls["Email"].value,
        "Trans_Type": "EmailID",
        "Flag": "V",
        "OTP": this.EmailLoginForm.controls["EmailOTP"].value,
        "RandomKey": RandomKey
      };
      var json = JSON.stringify(EmailVerifyRequest);
      this.LoginService.JMOTPEmail(json).subscribe(
        (response: any) => {
          let key = ''
          let message = ''
          let res = JSON.parse(this.EncrdecrService.getDecr(response))

          key = res.Message.split('|')[0]
          message = res.Message.split('|')[1]
          this.Loader.hide();
          if (message == "Verified" && key == RandomKey) {
            this.CallAlertModal("OTP Verified Successfully");
            const json = {
              "MobileNo": "",
              "Email": this.EmailLoginForm.controls["Email"].value,
              "flag": "BasedOnEmail",
              "UserType": this.UserType
            }
            this.Loader.show();
            let data = JSON.stringify(json)
            this.LoginService.fetchSubBrokerDetailsBasedOnMobile(data).subscribe(
              (response: any) => {
                let res = JSON.parse(this.EncrdecrService.getDecr(response))
                this.Loader.hide();
                if (res.ArrayOfResponse != null && res.ArrayOfResponse != undefined) {
                  // if(res.ArrayOfResponse.length === 1 || res.ArrayOfResponse.length >= 1){
                  if (res.ArrayOfResponse.length === 1) {
                    let password = this.EncrdecrService.getDecr(res.ArrayOfResponse[0].Password)
                    const json = {
                      "Username": res.ArrayOfResponse[0].SubBrokerCode,
                      "Password": password
                    }
                    let databody = JSON.stringify(json);
                    this.callAuthenticationController(databody)
                  } else {
                    if (res.ArrayOfResponse.length === 0) {
                      this.CallAlertModal("unauthorized user Sorry contact Branch.");
                      this.EmailLoginForm.reset();
                    } else {
                      this.Loader.hide();
                      this.ClientDataBasedOnEmail = res.ArrayOfResponse;
                      this.isEmailListDisplay = true;
                      $('#AlertModal').modal('hide');
                      $('#AlertModalLoginEmail').modal({
                        backdrop: 'static',
                        keyboard: false
                      });
                    }
                  }
                }
              }, (err: any) => {
                console.log(err);
                this.Loader.hide();
              })
          } else if (res.Message == "OTP Code is Expired") {
            this.CallAlertModal("OTP Code is Expired")
            this.EmailLoginForm.reset();
          } else if (res.Message == "User Not Exist") {
            this.CallAlertModal(res.Message);
            this.EmailLoginForm.reset();
            this.isEmailListDisplay = false;
          } else if (res.Message == "Overlimit") {
            this.CallAlertModal("Overlimit!! please try after 5 minutes.");
            this.EmailLoginForm.reset();
            this.isEmailListDisplay = false;
          } else if (res.Message == "Invalid OTP Code") {
            this.CallAlertModal("Invalid OTP Code");
            this.EmailLoginForm.reset();
            this.isEmailListDisplay = false;
          } else {
            this.CallAlertModal("Verified operation Faild...")
            this.EmailLoginForm.reset();
            this.isEmailListDisplay = false;
          }
        }, (err: any) => {
          console.log(err);
          this.Loader.hide();
        })
    }
  }

  OnClickClientSelection(clientDetails: any) {
    if (clientDetails != undefined && clientDetails != null) {
      this.Loader.show();
      let password = this.EncrdecrService.getDecr(clientDetails.Password)
      const json = {
        "Username": clientDetails.SubBrokerCode,
        "Password": password
      }
      let databody = JSON.stringify(json);
      this.callAuthenticationController(databody)
    } else {
      this.CallAlertModal("Something goes Wrong");
    }
  }

  BasedonEmailSelection(clientDetails: any) {
    if (clientDetails != undefined && clientDetails != null) {
      this.Loader.show();
      let password = this.EncrdecrService.getDecr(clientDetails.Password)
      const json = {
        "Username": clientDetails.SubBrokerCode,
        "Password": password
      }
      let databody = JSON.stringify(json);
      this.callAuthenticationController(databody)
    } else {
      this.CallAlertModal("Something goes Wrong");
    }
  }

  onSubmit() {
    debugger;
    this.LoginSubmitted = true;

    // if (this.ngCodifyOtpInput) {
    //   this.ngCodifyOtpInput.setValue('');
    // }
    if (this.LoginForm.invalid) {
      return;
    } else {
      this.IsShowInvalidOTPMsg = false;
      

      this.Loader.show()
  let clientInfoReq = {
            "Username": this.LoginForm.controls['Username'].value,
            "Password": this.LoginForm.controls['Password'].value
          }

          const DataBody = JSON.stringify(clientInfoReq);
          //this.GetClientPanInfoLogin(DataBody,"")
          this.clientProfileService.getIPAddress().subscribe((res:any)=>{  
            debugger
            let ipAddress=res.ip;
            this.GetClientPanInfoLogin(DataBody,ipAddress)
          },
          error => {
            this.GetClientPanInfoLogin(DataBody,"")
          })

      // this.LoginService.CodifyLogin_ENC(DataBody).subscribe(
      //   (res: any) => {
      //     if (res.length > 0) {
      //       this.Loader.hide();
      //       if (res[0].result.success == "Success") {
      //         // this.StartTimer();
      //         this.CodifyValidateRes = res[0].result
      //         $("#AlertModalPANVerification").modal({
      //           backdrop: 'static',
      //           keyboard: false
      //         });
      //         setTimeout(() => {
      //           $("#PANBox").focus();
      //         }, 200);
      //         // let id = $('.ng-otp-input-wrapper .otp-input:first-child').attr('id');
      //         // console.log(id);
      //         // this.ngCodifyOtpInput.focusTo(id);
      //         // if (res[0].result.mobileNumber != null && res[0].result.mobileNumber != "") {
      //         //   $('#sendedOTPMobileNumber').text(res[0].result.mobileNumber);
      //         // }
      //         // if (res[0].result.emailId != null && res[0].result.emailId != "") {
      //         //   $('#sendedOTPEmailId').text(res[0].result.emailId);
      //         // }
      //         this.Loader.hide();
      //       }
      //       else {
      //         if (res[0].result.message == "Invalid userid or password.") {
      //           this.CallAlertModal("The username or password you entered is incorrect.");// 21/02/2025 Only Message changed by Tishya
      //         } else {
      //           this.CallAlertModal(res[0].result.message);
      //         }
      //         this.Loader.hide();
      //       }
      //     }
      //     else {
      //       this.CallAlertModal("Something went wrong please try again");
      //       this.Loader.hide()
      //     }
      //   },
      //   (err: any) => {
      //     this.Loader.hide();
      //   }
      // );
    }

  }

  get codifyOTPForm() {
    return this.CodifyOTPForm.controls;
  }

  get codifyPANForm() {
    return this.CodifyPANForm.controls;
  }

  onSubmitVerifyPAN() {
    debugger
    this.PANFormSubmitted = true;
    this.Loader.show()

    if (this.CodifyPANForm.invalid) {
      this.Loader.hide();
      return;
    } else {
      const request = {
        userId: this.LoginForm.controls['Username'].value, 
        token: this.CodifyPANForm.controls['PAN'].value
      }
  
      var json = JSON.stringify(request);
  
      this.LoginService.VerifyPAN(json).then((res:any) => {
          if (res.Message == "Exists" || res == "Exists") {
            //this.accessToken = res[0].result.accessToken;
            // this.Loader.show();
            this.GetClientPanInfo(this.LoginForm.controls['Username'].value);
            // $("#AlertModalOTPVerification").modal('hide')
          }
          else if (res.Message == "Not Exists" || res == "Not Exists") {
            // this.IsShowInvalidOTPMsg = true;
            // this.ngCodifyOtpInput.setValue('');
            this.CodifyPANForm.controls['PAN'].setValue("");
            this.CallAlertModal("Entered PAN doesn't match with the User ID");
            this.PANFormSubmitted = false;
            this.Loader.hide()
          }
      },
        (err: any) => {
          this.CallAlertModal(err.statusText);
          $("#AlertModalPANVerification").modal('hide')
          this.CodifyPANForm.controls['PAN'].setValue("");
          this.Loader.hide()
        }
      );
    }
  }

  onSubmitVerifyOTP() {
    this.OTPFormSubmitted = true;
    this.Loader.show()

    const request = {
      userId: this.CodifyValidateRes.userId,
      receivedOtp: this.CodifyOTPForm.controls['OTP'].value,
      token: this.CodifyValidateRes.token
    }

    var json = JSON.stringify(request);

    this.LoginService.SendOTP_ENC(json).subscribe(res => {
      if (res.length > 0) {
        if (res[0].result.success == "Success") {
          this.accessToken = res[0].result.accessToken;
          // this.Loader.show();
          this.GetClientPanInfo(res[0].result);
          // $("#AlertModalOTPVerification").modal('hide')
        }
        else {
          this.IsShowInvalidOTPMsg = true;
          // this.ngCodifyOtpInput.setValue('');
          this.OTPFormSubmitted = false;
          this.Loader.hide()
        }
      }
      else {
        this.CallAlertModal("Something went wrong please try again");
        $("#AlertModalOTPVerification").modal('hide')
        this.Loader.hide()
      }
    },
      (err: any) => {
        this.CallAlertModal(err.statusText);
        $("#AlertModalOTPVerification").modal('hide')
        this.Loader.hide()
      }
    );
  }

  GetClientPanInfo(userId: any) {
    $("#AlertModalPANVerification").modal('hide')
    const request = {
      userId: userId,
    }

    var json = JSON.stringify(request);
    // this.Loader.show();
    this.LoginService.GetClientPanInfo(json).then((res1:any) => {
      let res = JSON.parse(this.EncrdecrService.getDecr(res1));
      if (res.ArrayOfResponse.length > 0) {
        // this.Loader.show();
        // this.onPanNumberLogin(res.ArrayOfResponse);
        this.LoginSubmitted = true;
        if (res.ArrayOfResponse == null) {
          return;
        }
        else {
          // this.Loader.show();

          let clientInfoReq = {
            "Username": res.ArrayOfResponse[0].PANNo,
            "Password": this.EncrdecrService.getDecr(res.ArrayOfResponse[0].password)
          }

          const DataBody = JSON.stringify(clientInfoReq);
          //this.GetClientPanInfoLogin(DataBody,"")
          this.clientProfileService.getIPAddress().subscribe((res:any)=>{  
            debugger
            let ipAddress=res.ip;
            this.GetClientPanInfoLogin(DataBody,ipAddress)
          },
          error => {
            this.GetClientPanInfoLogin(DataBody,"")
          })
        }
      }
      else {
        this.CallAlertModal(res.Message);
        this.Loader.hide();
      }
    });
    
  }

  GetClientPanInfoLogin(DataBody:any,IpAdd:any){
    sessionStorage.setItem('Tgsh@#3734fjfskshh==', IpAdd);
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    this.LoginService.PostLogin_NSE_Info(DataBody, this.UserType, IpAddress).then(
      (res1: any) => {
        debugger;
        let res = JSON.parse(this.EncrdecrService.getDecr(res1));
        // this.Loader.show();
        let resMessage = "";
        if (!isNullOrUndefined(res.Message)) {
          resMessage = res.Message;
        }
        else {
          resMessage = res;
        }
        if (resMessage != "Invalid Username and Password" && res.TOKEN_ID != null) {
          console.log("TxStatusId: " + JSON.stringify(res));
          sessionStorage.setItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF', this.EncrdecrService.setEncr("1"));
          sessionStorage.setItem('YKHkxDnoSoOe6PdTjKrqfm4z6', this.EncrdecrService.setEncr("19"));
          sessionStorage.setItem('`huR,8@RK9^??b4 -.hfs!!uR,XX', res.TOKEN_ID);
          sessionStorage.setItem('F44sGAGh2xwkpUL', res.LOGIN_ID); // Session_SubBrokerId
          sessionStorage.setItem('V4WGROuLLBE6t98', res.USER_NAME); // Session_UserName
          sessionStorage.setItem('V8hpPfITcxhEI9x', res.EMAIL_ID); // Session_UserEmail
          sessionStorage.setItem('3erT@Qr65TdXwq1', res.LOGIN_ID);//Added by Bhushan
          sessionStorage.setItem('Xe003SRRyYEoOC2', res.MOBILE); // Session_UserMobile
          // let login_id = this.EncrdecrService.getDecr(res.LOGIN_ID)
          // let SubBrokerCode = this.EncrdecrService.getDecr(res.SubBrokerCode);
          // let EmpCode = this.EncrdecrService.getDecr(res.EmployeeCode);
          // let USER_ID = this.EncrdecrService.getDecr(res.USER_ID)
          //this.ShowHideHeaderMenu.show();
          sessionStorage.setItem('pOWgAF62qFXnZMn', ''); // RazorCustId
          sessionStorage.setItem('Hldq31TLYwRbLJ8', res.SubBrokerCode); // Session_SubBrokerCode
          sessionStorage.setItem('L2D3506kIHSk3E0', res.USER_TYPE); // Session_UserType
          sessionStorage.setItem('qAkZrQYLWNBSlki', res.LOGIN_ID); // Session_CBId
          sessionStorage.setItem('pi4ZU2P3M8JE4q7', ''); // Session_B64CompanyLogo
          sessionStorage.setItem('SBLoginBase64PP', res.SBLogoBase64); //IFD Logo : Added by Saddam

          if (res.Family_ID !== null && res.Family_ID !== undefined && res.Family_ID !== 'null') {
            sessionStorage.setItem('hn0bHyGhfpGtrPe', res.Family_ID);  // Session_Family_ID
          }
          let ut = res.USER_TYPE;
          if (ut != undefined && ut != null && ut != '') {
            if (this.EncrdecrService.getDecr(ut) == '3') {
              sessionStorage.setItem('m5JkoXISmYRAIuY', res.USER_ID); // Session_UserId
              this.USERLoginId = res.USER_ID;
              sessionStorage.setItem('UZT6qHaDZSz66kx', res.LOGIN_ID); // Session_ClientBasicInfoId
              sessionStorage.setItem('N1QJHdOkO7Hz8QC', res.LOGIN_ID);
              sessionStorage.setItem('ySxterqMDG7RY2qTpuzrfA', this.EncrdecrService.setEncr("1"));
              sessionStorage.setItem('AqVk7klfa+b0nlVjO8Y90I=', res.RiskProfile); //Aggressive/Moderate etc
              sessionStorage.setItem('aaIHl0pIiYe71gyyxC/5xA==', res.RiskProfileStatus);//Active or Expired
              sessionStorage.setItem('LWHTWnSDkv4+qaQXsO6tHYU=', res.RiskProfileLevel); //risk Level of client
              sessionStorage.setItem('6l0NqN5kkIZCaDvdzUfYVK8g=', res.RiskProfileInsertedDate);
              sessionStorage.setItem('TF4q3aPcsYpaEDoa4ROM', res.TxStatus); //TxStatusId of Client
              sessionStorage.setItem('cABJtw0TY2XnfyQkiMI4', res.ClientType);
              sessionStorage.setItem('4MPLG9aocUy5o5wwX9r3aA',res.UCCCode);//Ucc Code of Client Added by Tishya
              console.log("Login Response: " + JSON.stringify(res));


              //Added by Dalsukh
              this.G_ClientBasicInfoId = this.EncrdecrService.getDecr(sessionStorage.getItem('UZT6qHaDZSz66kx'));

              this.CompanyName = this.ClientDataService.GetCompanyName();
              this.UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')));
              if (!(!!sessionStorage.getItem('bXHnuiS89&#jk##'))) {
                sessionStorage.setItem('thnjiokgrthn', this.EncrdecrService.setEncr(this.G_ClientBasicInfoId)); // Session_ClientBasicInfoId,aditya
                sessionStorage.setItem('edcrfvbhunji', this.EncrdecrService.setEncr(this.UserType.toString())); // Session_client userType,aditya
              }
              // Added by Tishya for IIFL-2030
              let rr1 = '',rr2 = '',rr3 = '',rr4 = '' 
              // let r1 = sessionStorage.getItem('m5JkoXISmYRAIuY'); //Session UserId
             let r1 = sessionStorage.getItem('4MPLG9aocUy5o5wwX9r3aA'); //Session UCCCode
              let r2 = sessionStorage.getItem('L2D3506kIHSk3E0'); //Session UserType
              let r3 = sessionStorage.getItem('V8hpPfITcxhEI9x'); //Session EmailId
              let r4 = sessionStorage.getItem('Xe003SRRyYEoOC2'); //Session UserMobile

              if(r1){
                rr1 = this.EncrdecrService.getDecr(r1);
              }
              if(r2){
                rr2 = this.EncrdecrService.getDecr(r2);
              }
              if(r3){
                rr3 = this.EncrdecrService.getDecr(r3);
              }
              if(r4){
                let Tax_statusId = this.EncrdecrService.getDecr(sessionStorage.getItem("TF4q3aPcsYpaEDoa4ROM")).toString();
                rr4 = this.EncrdecrService.getDecr(r4);
                if(Tax_statusId =="21" || Tax_statusId == "24")
                {
                  rr4 = "";
                }else{
                  rr4 = rr4.includes('+91') ? rr4.replace(/\s+/g, '') : `+91${rr4.trim()}`
                }
              }

              let UserInfo = {
                "Site":{
                  "Identity":rr1,
                  "UserType":rr2,
                  "Email":rr3,
                  "Phone":rr4
                }
              }
              console.log("CleverTap UserLoginEvent : ", UserInfo);
              
              this.Clevertap.userLoginEvent(UserInfo);
              //Ended by Tishya
              if(this.IsFromDeepLink){
                window.location.href = '/deeplink-redirector';
              }
              else {
                if (this.URL != "") {
                  if(this.APPSOURCE == "web" || this.APPSOURCE == "mfweb" || this.APPSOURCE == "Web" || this.APPSOURCE == "MFWEB" || this.APPSOURCE == "IIFLMARKETSWEB"){}
                  else{
                    sessionStorage.setItem("dfrs980f9vdfug", "MobileDashboard");
                    this.Loader.hideMenu();
                  }
                  if (this.URL == "reports-new/portfolio-report-combine") {
  
                    sessionStorage.setItem("@ssdhg$hwhy3u#a8bf", this.EncrdecrService.setEncr("FromAspx"))
                  }
                  // this.router.navigate(["/" + this.URL], { relativeTo: this.route });
                  window.location.href = `/${this.URL}`;
                  return;
                }
  
                if (this.utm_source == "") {
                  // this.Loader.show();
                  sessionStorage.setItem("3erT@Qr65TdXwq1", res.LOGIN_ID);
                  $("#AlertModalOTPVerification").modal('hide')
                  // window.location.href = `/client-dashboard?cc=${this.CodifyValidateRes.userId}&tt=${this.accessToken}`;
                  window.location.href = this.TakeMeToPage || '/client-dashboard';
                } else {
                  if ((this.utm_source == res.LOGIN_ID)) {
                    //sessionStorage.setItem("3erT@Qr65TdXwq1", res.LOGIN_ID);
                    // this.router.navigate(["/Client-Profile-Preview/Preview"]);
  
                    window.location.href = '/Client-Profile-Preview/Preview'
                  } else {
                    this.CallAlertModal("Please select the correct user to proceed.");
                    sessionStorage.clear();
                    return;
                  }
                }
              }

              //Microsoft Clarity Code Starts
              let id = this.USERLoginId;

              if (id != null && id != undefined && id != '') {
                id = this.EncrdecrService.getDecr(id);
                sessionStorage.removeItem('cl2342wrty'); ///21062024
                sessionStorage.setItem('cl2342wrty', id)
              }

            }
            else {
              this.CallAlertModal('Please enter valid username and password');
            }
          }
          else {
            this.CallAlertModal('Please enter valid username and password');
          }
        }
        else if (resMessage.includes("This feature is not available for your login")) {
          // this.CallAlertModal(resMessage);
          this.CallAlertModal("To activate your login, please contact your distributor")
        }
        else {
          this.CallAlertModal('Please enter valid username and password');
        }
        this.Loader.hide();
      },
      (err: any) => {
        const rr = err.error;
        const er = rr.substring(1, rr.length - 1);
        const rk = er.split(', ');
        this.Loader.hide();
        this.CallAlertModal('Please enter valid username and password');
      }
    );
  }


  onPanNumberLogin(clientInfo: any) {
    this.LoginSubmitted = true;
    if (clientInfo == null) {
      return;
    }
    else {
      this.Loader.show();

      let clientInfoReq = {
        "Username": clientInfo[0].PANNo,
        "Password": this.EncrdecrService.getDecr(clientInfo[0].password)
      }

      const DataBody = JSON.stringify(clientInfoReq);
      // sessionStorage.setItem('Tgsh@#3734fjfskshh==', '173.212.234.56');
      // let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
      // this.LoginService.PostLogin_NSE_Info(DataBody, this.UserType, IpAddress).subscribe(
      //   (res: any) => {
      //     debugger;
      //     this.Loader.show();
      //     let resMessage = "";
      //     if (!isNullOrUndefined(res.Message)) {
      //       resMessage = res.Message;
      //     }
      //     else {
      //       resMessage = res;
      //     }
      //     if (resMessage != "Invalid Username and Password" && res.TOKEN_ID != null) {
      //       console.log("TxStatusId: " + JSON.stringify(res));
      //       sessionStorage.setItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF', this.EncrdecrService.setEncr("1"));
      //       sessionStorage.setItem('YKHkxDnoSoOe6PdTjKrqfm4z6', this.EncrdecrService.setEncr("19"));
      //       sessionStorage.setItem('`huR,8@RK9^??b4 -.hfs!!uR,XX', res.TOKEN_ID);
      //       sessionStorage.setItem('F44sGAGh2xwkpUL', res.LOGIN_ID); // Session_SubBrokerId
      //       sessionStorage.setItem('V4WGROuLLBE6t98', res.USER_NAME); // Session_UserName
      //       sessionStorage.setItem('V8hpPfITcxhEI9x', res.EMAIL_ID); // Session_UserEmail
      //       sessionStorage.setItem('3erT@Qr65TdXwq1', res.LOGIN_ID);//Added by Bhushan
      //       sessionStorage.setItem('Xe003SRRyYEoOC2', res.MOBILE); // Session_UserMobile
      //       // let login_id = this.EncrdecrService.getDecr(res.LOGIN_ID)
      //       // let SubBrokerCode = this.EncrdecrService.getDecr(res.SubBrokerCode);
      //       // let EmpCode = this.EncrdecrService.getDecr(res.EmployeeCode);
      //       // let USER_ID = this.EncrdecrService.getDecr(res.USER_ID)
      //       //this.ShowHideHeaderMenu.show();
      //       sessionStorage.setItem('pOWgAF62qFXnZMn', ''); // RazorCustId
      //       sessionStorage.setItem('Hldq31TLYwRbLJ8', res.SubBrokerCode); // Session_SubBrokerCode
      //       sessionStorage.setItem('L2D3506kIHSk3E0', res.USER_TYPE); // Session_UserType
      //       sessionStorage.setItem('qAkZrQYLWNBSlki', res.LOGIN_ID); // Session_CBId
      //       sessionStorage.setItem('pi4ZU2P3M8JE4q7', ''); // Session_B64CompanyLogo
      //       sessionStorage.setItem('SBLoginBase64PP', res.SBLogoBase64); //IFD Logo : Added by Saddam

      //       if (res.Family_ID !== null && res.Family_ID !== undefined && res.Family_ID !== 'null') {
      //         sessionStorage.setItem('hn0bHyGhfpGtrPe', res.Family_ID);  // Session_Family_ID
      //       }
      //       let ut = res.USER_TYPE;
      //       if (ut != undefined && ut != null && ut != '') {
      //         if (this.EncrdecrService.getDecr(ut) == '3') {
      //           sessionStorage.setItem('m5JkoXISmYRAIuY', res.USER_ID); // Session_UserId
      //           this.USERLoginId = res.USER_ID;
      //           sessionStorage.setItem('UZT6qHaDZSz66kx', res.LOGIN_ID); // Session_ClientBasicInfoId
      //           sessionStorage.setItem('N1QJHdOkO7Hz8QC', res.LOGIN_ID);
      //           sessionStorage.setItem('ySxterqMDG7RY2qTpuzrfA', this.EncrdecrService.setEncr("1"));
      //           sessionStorage.setItem('AqVk7klfa+b0nlVjO8Y90I=', res.RiskProfile); //Aggressive/Moderate etc
      //           sessionStorage.setItem('aaIHl0pIiYe71gyyxC/5xA==', res.RiskProfileStatus);//Active or Expired
      //           sessionStorage.setItem('LWHTWnSDkv4+qaQXsO6tHYU=', res.RiskProfileLevel); //risk Level of client
      //           sessionStorage.setItem('6l0NqN5kkIZCaDvdzUfYVK8g=', res.RiskProfileInsertedDate);
      //           sessionStorage.setItem('TF4q3aPcsYpaEDoa4ROM', res.TxStatus); //TxStatusId of Client
      //           sessionStorage.setItem('cABJtw0TY2XnfyQkiMI4', res.ClientType);
      //           console.log("Login Response: " + JSON.stringify(res));


      //           //Added by Dalsukh
      //           this.G_ClientBasicInfoId = this.EncrdecrService.getDecr(sessionStorage.getItem('UZT6qHaDZSz66kx'));

      //           this.CompanyName = this.ClientDataService.GetCompanyName();
      //           this.UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')));
      //           if (!(!!sessionStorage.getItem('bXHnuiS89&#jk##'))) {
      //             sessionStorage.setItem('thnjiokgrthn', this.EncrdecrService.setEncr(this.G_ClientBasicInfoId)); // Session_ClientBasicInfoId,aditya
      //             sessionStorage.setItem('edcrfvbhunji', this.EncrdecrService.setEncr(this.UserType.toString())); // Session_client userType,aditya
      //           }

      //           if (this.URL != "") {
      //             sessionStorage.setItem("dfrs980f9vdfug", "MobileDashboard");
      //             this.Loader.hideMenu();
      //             if (this.URL == "reports-new/portfolio-report-combine") {

      //               sessionStorage.setItem("@ssdhg$hwhy3u#a8bf", this.EncrdecrService.setEncr("FromAspx"))
      //             }
      //             this.router.navigate(["/" + this.URL], { relativeTo: this.route });
      //             return;
      //           }

      //           if (this.utm_source == "") {
      //             this.Loader.show();
      //             sessionStorage.setItem("3erT@Qr65TdXwq1", res.LOGIN_ID);
      //             window.location.href = `/client-dashboard`;
      //           } else {
      //             if ((this.utm_source == res.LOGIN_ID)) {
      //               //sessionStorage.setItem("3erT@Qr65TdXwq1", res.LOGIN_ID);
      //               // this.router.navigate(["/Client-Profile-Preview/Preview"]);
      //               window.location.href = '/Client-Profile-Preview/Preview'
      //             } else {
      //               this.CallAlertModal("Please select the correct user to proceed.");
      //               sessionStorage.clear();
      //               return;
      //             }
      //           }
      //           //Microsoft Clarity Code Starts
      //           let id = this.USERLoginId;

      //           if (id != null && id != undefined && id != '') {
      //             id = this.EncrdecrService.getDecr(id);
      //             sessionStorage.removeItem('cl2342wrty'); ///21062024
      //             sessionStorage.setItem('cl2342wrty', id)
      //           }





      //           //   setTimeout(() => {
      //           //     $("#addedScript").remove();
      //           //     var head = document.getElementsByTagName('head')[0];
      //           //     var script = document.createElement('script');
      //           //     script.type = 'text/javascript';
      //           //     script.setAttribute('id', 'addedScript');
      //           //     script.text = `
      //           //   debugger
      //           //   let clid = sessionStorage.getItem('cl2342wrty')
      //           //   let currentUserId = '0' ;
      //           //   if(clid != null && clid != undefined && clid != ''){
      //           //       currentUserId = clid;
      //           //   }

      //           //   (function(c,l,a,r,i,t,y){
      //           //     c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      //           //     t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      //           //     y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      //           //     clarity("set", "userId", currentUserId.toString());
      //           //     console.log(currentUserId.toString())
      //           // })(window, document, "clarity", "script", "myvdl8jnsv");
      //           //   `
      //           //     head.appendChild(script);
      //           //   }, 500);
      //           //Microsoft Clarity Code Ends


      //         }
      //         else {
      //           this.CallAlertModal('Please enter valid username and password');
      //         }
      //       }
      //       else {
      //         this.CallAlertModal('Please enter valid username and password');
      //       }
      //     }
      //     else if (resMessage.includes("This feature is not available for your login")) {
      //       // this.CallAlertModal(resMessage);
      //       this.CallAlertModal("To activate your login, please contact your distributor")
      //     }
      //     else {
      //       this.CallAlertModal('Please enter valid username and password');
      //     }
      //     this.Loader.hide();
      //   },
      //   (err: any) => {
      //     const rr = err.error;
      //     const er = rr.substring(1, rr.length - 1);
      //     const rk = er.split(', ');
      //     this.Loader.hide();
      //     this.CallAlertModal('Please enter valid username and password');
      //   }
      // );
      this.clientProfileService.getIPAddress().subscribe((res:any)=>{  
        debugger
        let ipAddress=res.ip;
        this.GetClientPanInfoLogin(DataBody,ipAddress)
      },
      error => {
        this.GetClientPanInfoLogin(DataBody,"")
      })
    }
  }

  onOtpChange(e) {
    let val = e;
    let v = '';
    v = v + val;
    this.CodifyOTPForm.controls["OTP"].setValue(v);
  }

  onSubmitOld() {
    debugger
    this.LoginSubmitted = true;
    //if (!this.LoginForm.invalid ) {//old conditin
    //condition changed by dalsukh for sso login without password
    if (this.LoginForm.invalid && !(!isNullOrUndefined(sessionStorage.getItem("1rMWoq/fR0KsYA9AxL63Cw==")) && !isNullOrUndefined(sessionStorage.getItem("HNrvPKl2xEC1ZGyPqCxAOQ==")) && !isNullOrUndefined(sessionStorage.getItem("+TrzWUXUJ0Cd20+J77gj4A==")))) {
      return;
    }
    else {

      //////
      this.Loader.show()
      let DataBody = JSON.stringify(this.LoginForm.value);
      sessionStorage.setItem('Tgsh@#3734fjfskshh==', '173.212.234.56');
      let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
      debugger
      let LoginSource = "";

      //setting flag based on sso login or normal based on session
      if (!isNullOrUndefined(sessionStorage.getItem("1rMWoq/fR0KsYA9AxL63Cw==")) && !isNullOrUndefined(sessionStorage.getItem("HNrvPKl2xEC1ZGyPqCxAOQ==")) && !isNullOrUndefined(sessionStorage.getItem("+TrzWUXUJ0Cd20+J77gj4A=="))) {
        LoginSource = "SSO";

      }

      this.LoginService.PostLogin_NSE_Info(DataBody, this.UserType, IpAddress, LoginSource).then(
        (res1: any) => {
          debugger
          let res = JSON.parse(this.EncrdecrService.getDecr(res1));
          this.RedirectByLink();
          if (res.Message != "Invalid Username and Password") {
            sessionStorage.setItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF', this.EncrdecrService.setEncr("1"));
            sessionStorage.setItem('`huR,8@RK9^??b4 -.hfs!!uR,XX', res.TOKEN_ID);
            sessionStorage.setItem('m5JkoXISmYRAIuY', res.USER_ID);
            sessionStorage.setItem('F44sGAGh2xwkpUL', res.LOGIN_ID); //Session_SubBrokerId
            sessionStorage.setItem('V4WGROuLLBE6t98', res.USER_NAME); //Session_UserName
            sessionStorage.setItem('V8hpPfITcxhEI9x', res.EMAIL_ID); //Session_UserEmail
            sessionStorage.setItem('Xe003SRRyYEoOC2', res.MOBILE); //Session_UserMobile

            sessionStorage.setItem("kioh298hKh2kj", res.CorpIFDStatus);//CorpIFDFlag -- for corporate IFD
            sessionStorage.setItem("23khokl2k35hl", res.PrimarySBCode);//PrimarySubBrokerCode -- for corporate IFD
            sessionStorage.setItem("ZhdfjU423HG878", res.IsChildSB); //IsChildSB : Boolean Value -- Added by Saddam
            sessionStorage.setItem("sd7BSDxhjk876f", res.IsMasterFranchise); //IsMasterFranchise Flag : (1 : MasterFranchise & 0 : Not) -- Added by Saddam
            sessionStorage.setItem("fh9XFbhbd83r87", res.IsCorporateIFD); //IsCorporateIFD Flag : (1 : CorporateIFD & 0 : Not) -- Added by Saddam
            sessionStorage.setItem('ksdhUEDH78$#OPL', res.UserIPAddress);  // Logged In User IP Address : Added by Saddam
            sessionStorage.setItem('Sdfg0978&#NlpmB', res.CorporateIFDSBCode);  // Corporate IFD SB Code : Added by Saddam

            // let login_id = this.EncrdecrService.getDecr(res.LOGIN_ID)
            // let SubBrokerCode = this.EncrdecrService.getDecr(res.SubBrokerCode);
            // let USER_ID = this.EncrdecrService.getDecr(res.USER_ID)

            if (res.RazorCustId !== null && res.RazorCustId !== undefined && res.RazorCustId !== 'null') {
              sessionStorage.setItem('pOWgAF62qFXnZMn', res.RazorCustId); //RazorCustId
            }
            else {
              sessionStorage.setItem('pOWgAF62qFXnZMn', ''); //RazorCustId
            }
            sessionStorage.setItem('Hldq31TLYwRbLJ8', res.SubBrokerCode); //Session_SubBrokerCode
            sessionStorage.setItem('L2D3506kIHSk3E0', res.USER_TYPE); //Session_UserType
            sessionStorage.setItem('qAkZrQYLWNBSlki', res.LOGIN_ID); //Session_CBId
            sessionStorage.setItem('pi4ZU2P3M8JE4q7', ''); //Session_B64CompanyLogo

            //sessionStorage.setItem('Session_B64CompanyLogo_EtE',res.Companylogobase64);
            if (res.Family_ID !== null && res.Family_ID !== undefined && res.Family_ID !== 'null') {
              sessionStorage.setItem('hn0bHyGhfpGtrPe', res.Family_ID);  //Session_Family_ID
            }
            switch (this.EncrdecrService.getDecr(res.USER_TYPE)) {
              case "2":

                sessionStorage.setItem('m5JkoXISmYRAIuY', res.SubBrokerCode); //Session_UserId
                this.USERLoginId = res.SubBrokerCode
                sessionStorage.setItem('currentstatus', res.CurrentStatus);



                console.log("LogoImage", res.SBLoginBase64PP);

                // if (res.SBLogoBase64 != null && res.SBLogoBase64 != "" && res.SBLogoBase64 != undefined) {
                //   sessionStorage.setItem('SBLoginBase64PP', res.SBLogoBase64);


                // }




                if (!isNullOrUndefined(sessionStorage.getItem("sdfetrtr"))) {
                  let fdData = sessionStorage.getItem("sdfetrtr");
                  window.location.href = '/fd/fd-landing';
                  sessionStorage.removeItem('sdfetrtr');
                }
                else if (!isNullOrUndefined(sessionStorage.getItem("fgrtrytyt"))) {
                  let mfData = sessionStorage.getItem("fgrtrytyt");
                  window.location.href = 'transaction-new/lumpsum';
                  sessionStorage.removeItem('fgrtrytyt');
                }
                else if (!isNullOrUndefined(localStorage.getItem("isnfoyes"))) {

                  let nfoData = localStorage.getItem("isnfoyes");

                  setTimeout(() => {
                    window.location.href = 'explore-funds-new';
                  }, 1000)
                  // localStorage.removeItem('isnfoyes');
                }
                else if (!isNullOrUndefined(localStorage.getItem("ispreferyes"))) {

                  let preferschemeData = localStorage.getItem("ispreferyes");

                  setTimeout(() => {
                    window.location.href = 'explore-funds-new';
                  }, 1000)
                  // localStorage.removeItem('isprefe ryes');
                }
                else if (this.redirectTo != "") {
                  setTimeout(() => {
                    window.location.href = this.redirectTo;
                  }, 1000)
                }
                //Added by Dalsukh SSO verification Module
                else if (!isNullOrUndefined(sessionStorage.getItem("1rMWoq/fR0KsYA9AxL63Cw==")) && !isNullOrUndefined(sessionStorage.getItem("HNrvPKl2xEC1ZGyPqCxAOQ==")) && !isNullOrUndefined(sessionStorage.getItem("+TrzWUXUJ0Cd20+J77gj4A=="))) {
                  this.Loader.hide();
                  sessionStorage.removeItem('1rMWoq/fR0KsYA9AxL63Cw==');
                  sessionStorage.removeItem('HNrvPKl2xEC1ZGyPqCxAOQ==');
                  sessionStorage.removeItem('+TrzWUXUJ0Cd20+J77gj4A==');
                  //this.router.navigateByUrl("/" + this.PageURL);
                  window.location.href = "/" + this.PageURL;
                }
                //Ended by Dalsukh SSO verification Module
                else {
                  this.Loader.hide();
                  sessionStorage.setItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294', res.RazorePaymentStatus)
                  //this.router.navigate(['/payment'], { relativeTo: this.route });
                  //this.router.navigate(['/dashboard'], { relativeTo: this.route });
                  window.location.href = '/dashboard';
                }
                break;


            }
          }
          else {
            this.Loader.hide();
            this.CallAlertModal('Please enter valid username and password');
          }
        },
        (err: any) => {
          ////////
          //console.log(err)
          let rr = err.error;
          let er = rr.substring(1, rr.length - 1);
          let rk = er.split(", ");
          this.Loader.hide();
          if (rk[1].includes('Number of invalid login attempts')) {
            this.CallAlertModal('Number of invalid login attempts. Your account is locked for 15 minutes')
          }
          else {
            this.CallAlertModal('Please enter valid username and password');
          }
          ////console.log('err =>' + er);

        }

      );

    }
  }

  SendUserType() {
    //////
    sessionStorage.setItem('L2D3506kIHSk3E0', this.EncrdecrService.setEncr(this.UserType.toString()));
  }
  CallAlertModal(msg: any) {
    $("#AlertModal").modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#AlertModalContent').text(msg);
  }
  getCompanyDetails(para?) {
    this.ClientDataService.getCompanyDetails(environment.CompanyId).subscribe((data: any) => {
      if(para != 'no'){
        this.Loader.hide();
      }
      if (data != null && data.ArrayOfResponse.length != 0) {
        let rk = data.ArrayOfResponse[0];
        console.log('Corp_IFA = ' + this.EncrdecrService.getDecr(rk.Dummy1));
        //this.Companyname = rk.CompanyName;
        if (this.ClientDataService.GetCompanyName() == 'AU') {
          sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("4"));
          sessionStorage.setItem('Mnuoisns6wqgswj2$#', "1");
        }
        else if (this.ClientDataService.GetCompanyName() == 'Mahindra') {
          sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("2"));
          sessionStorage.setItem('Mnuoisns6wqgswj2$#', "0");
        }
        else if (this.ClientDataService.GetCompanyName() == 'YesSecurities') {
          sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("11"));
          sessionStorage.setItem('Mnuoisns6wqgswj2$#', "0");
        }
        else {
          sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("0"));
          sessionStorage.setItem('Mnuoisns6wqgswj2$#', "0");
        }

        sessionStorage.setItem('E#$%#XCha7%*=', this.EncrdecrService.getDecr(rk.Dummy2));
        sessionStorage.setItem('Vbhs@#%LMKIo=', this.EncrdecrService.getDecr(rk.Dummy1));
        sessionStorage.setItem('DufjGDH3843JE', this.EncrdecrService.getDecr(rk.Dummy4));
        sessionStorage.setItem('PfdkSJDNWks2323Ms', this.EncrdecrService.getDecr(rk.Dummy3));
        sessionStorage.setItem('Arh34SDBJSSiF', this.EncrdecrService.getDecr(rk.Dummy5));
        sessionStorage.setItem('Fhd63asja$%Wsdjs9304#@dfvdjfjd', this.EncrdecrService.getDecr(rk.Dummy6));

        sessionStorage.setItem('cIe+MhBUozWO3+mKZd2to=', this.EncrdecrService.getDecr(rk.EnableRiskProfile));
      }
      else{
        this.Loader.hide();
      }
    },
    err =>{
      this.Loader.hide();
    });
  }

  callAuthenticationController(DataBody: any) {

    sessionStorage.setItem('Tgsh@#3734fjfskshh==', '173.212.234.56');
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    this.LoginService.PostLogin_NSE_Info(DataBody, this.UserType, IpAddress).then(
      (res1: any) => {
        let res = JSON.parse(this.EncrdecrService.getDecr(res1));
        console.log('loginResp', res);
        if (res != "Invalid Username and Password") {
          sessionStorage.setItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF', this.EncrdecrService.setEncr("1"));
          sessionStorage.setItem('`huR,8@RK9^??b4 -.hfs!!uR,XX', res.TOKEN_ID);
          sessionStorage.setItem('m5JkoXISmYRAIuY', res.USER_ID);
          sessionStorage.setItem('F44sGAGh2xwkpUL', res.LOGIN_ID); //Session_SubBrokerId
          sessionStorage.setItem('V4WGROuLLBE6t98', res.USER_NAME); //Session_UserName
          sessionStorage.setItem('V8hpPfITcxhEI9x', res.EMAIL_ID); //Session_UserEmail
          sessionStorage.setItem('Xe003SRRyYEoOC2', res.MOBILE); //Session_UserMobile
          if (res.RazorCustId !== null && res.RazorCustId !== undefined && res.RazorCustId !== 'null') {
            sessionStorage.setItem('pOWgAF62qFXnZMn', res.RazorCustId); //RazorCustId
          }
          else {
            sessionStorage.setItem('pOWgAF62qFXnZMn', ''); //RazorCustId
          }
          sessionStorage.setItem('Hldq31TLYwRbLJ8', res.SubBrokerCode); //Session_SubBrokerCode
          sessionStorage.setItem('L2D3506kIHSk3E0', res.USER_TYPE); //Session_UserType
          sessionStorage.setItem('qAkZrQYLWNBSlki', res.LOGIN_ID); //Session_CBId
          sessionStorage.setItem('pi4ZU2P3M8JE4q7', ''); //Session_B64CompanyLogo

          //sessionStorage.setItem('Session_B64CompanyLogo_EtE',res.Companylogobase64);
          if (res.Family_ID !== null && res.Family_ID !== undefined && res.Family_ID !== 'null') {
            sessionStorage.setItem('hn0bHyGhfpGtrPe', res.Family_ID);  //Session_Family_ID
          }
          switch (this.EncrdecrService.getDecr(res.USER_TYPE)) {
            case "2":
              sessionStorage.setItem('m5JkoXISmYRAIuY', res.SubBrokerCode); //Session_UserId
              if (res.RazorePaymentStatus) {
                //this.router.navigate(['/dashboard'], { relativeTo: this.route });
                window.location.href = '/dashboard';
              }
              else {
                this.Loader.hide();
                sessionStorage.setItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294', res.RazorePaymentStatus)
                //this.router.navigate(['/payment'], { relativeTo: this.route });
                //this.router.navigate(['/dashboard'], { relativeTo: this.route });
                window.location.href = '/dashboard';
              }
              break;


          }
        }
        else {
          this.Loader.hide();
          this.CallAlertModal('Please enter valid username and password');
        }
      },
      (err: any) => {
        ////////
        //console.log(err)
        let rr = err.error;
        let er = rr.substring(1, rr.length - 1);
        let rk = er.split(", ");
        this.Loader.hide();
        if (rk[1].includes('Number of invalid login attempts')) {
          this.CallAlertModal('Number of invalid login attempts. Your account is locked for 15 minutes')
        }
        else {
          this.CallAlertModal('Please enter valid username and password');
        }
        ////console.log('err =>' + er);

      }

    );
  }

  generateRandomString(length) {
    let result = '';
    const charactersLength = this.characters.length;
    for (let i = 0; i < length; i++) {
      result += this.characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  RedirectByLink() {
    try {

      var fd_url = ('https://alpha.incredmarkets.com//login-cp?redirect_fd=fd/fd-landing');
      var mf_url = ('https://alpha.incredmarkets.com//login-cp?redirect_mf=transaction-new/lumpsum');
      var nfo_url = ('https://alpha.incredmarkets.com//login-cp?redirect_nfo=explore-funds-new&IsNFO=true');
      var preferscheme_url = ('https://alpha.incredmarkets.com//login-cp?redirect_preferscheme=explore-funds-new&IsPreferred=true');


      this.route.queryParams.subscribe((queryParam) => {
        if (queryParam.redirect_fd != undefined) {
          this.redirect_fd = queryParam.redirect_fd;
          sessionStorage.setItem("sdfetrtr", this.redirect_fd);
        }
      });

      this.route.queryParams.subscribe((queryParam) => {
        if (queryParam.redirect_mf != undefined) {
          this.redirect_mf = queryParam.redirect_mf;
          sessionStorage.setItem("fgrtrytyt", this.redirect_mf);
        }
      });

      this.route.queryParams.subscribe((queryParam) => {
        //
        if (queryParam.redirect_nfo != undefined) {
          this.redirect_nfo = queryParam.redirect_nfo;
          localStorage.setItem("isnfoyes", this.redirect_nfo);
        }
      });

      this.route.queryParams.subscribe((queryParam) => {

        if (queryParam.redirect_preferscheme != undefined) {
          this.redirect_preferscheme = queryParam.redirect_preferscheme;
          localStorage.setItem("ispreferyes", this.redirect_preferscheme);
        }
      });

      this.route.queryParams.subscribe((queryParam) => {

        if (queryParam.redirectTo != undefined) {
          this.redirectTo = queryParam.redirectTo;
        }
        if (queryParam.flag != undefined) {
          if (queryParam.flag == "NFO") {
            sessionStorage.setItem("Xb5weBH3kMGpXLalI=", "nfo");
          } else if (queryParam.flag == "PrefScheme") {
            sessionStorage.setItem("Xb5weBH3kMGpXLalI=", "ff");
          }
        }
      });
    } catch (error) {
      console.log(error)
    }
  }
  //Added by Dalsukh
  CodifyResentOTP() {
    debugger
    this.Loader.show();
    const request = {
      userId: this.CodifyValidateRes.userId,
      token: this.CodifyValidateRes.token
    }
    var json = JSON.stringify(request);
    this.LoginService.CodifyResendOTP(json).subscribe(res => {

      this.Loader.hide();
      if (res.length > 0) {
        this.Loader.hide();
        if (res[0].result.status == "Success") {
          this.CodifyValidateRes_ResendOTP = res[0].result
          console.log("Response: ", this.CodifyValidateRes_ResendOTP)
          $("#AlertModalOTPVerification").modal({
            backdrop: 'static',
            keyboard: false
          });
          let id = $('.ng-otp-input-wrapper .otp-input:first-child').attr('id');
          console.log(id);
          // this.ngCodifyOtpInput.focusTo(id);
          if (res[0].result.mobileNumber != null && res[0].result.mobileNumber != "") {
            $('#sendedOTPMobileNumber').text(res[0].result.mobileNumber);
          }
          if (res[0].result.emailId != null && res[0].result.emailId != "") {
            $('#sendedOTPEmailId').text(res[0].result.emailId);
          }
          this.Loader.hide();
          this.StartTimer();
        }
        else {
          this.CallAlertModal(res[0].result.message);
          this.Loader.hide();
        }
      }
      else {
        this.CallAlertModal("Something went wrong please try again");
        this.Loader.hide()
      }
    })
  }
  StartTimer() {
    debugger;
    this.Loader.hide();
    $(".res").removeClass("act").prop("disabled", true);
    this.isDisabled = true;
    let t = this.OtpTimer;
    this.OTP_Timer_Function = setInterval(function () {
      //
      if (t >= 0) {
        const minutes = Math.floor(t / 60);
        let seconds: any = t % 60;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }

        $("#Time").text(`0${minutes}:${seconds}`);
        console.log($("#Time").val())

        if (t === 0) {
          $(".res").addClass("act").prop("disabled", false);
          this.isDisabled = false;
          clearInterval(this.OTP_Timer_Function);
        }
        t -= 1;
      }
    }, 1000);
  }
  ClearIntervalOTP() {
    // this.ngCodifyOtpInput.setValue('');
    $('#Time').text(this.OtpTimeRemening);
    this.isDisabled = true;
    clearInterval(this.OTP_Timer_Function);
  }
  CloseMainModal() {
    this.bsModalRef.hide();
    this.CodifyPANForm.controls['PAN'].setValue("");
  }
}
